var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"container",attrs:{"type":"flex","justify":"space-around","gutter":9}},[_c('base-card',{attrs:{"path":_vm.newSwapPath,"card-message":_vm.newSwapMessage}}),_c('base-card',{attrs:{"path":_vm.existingSwapPath,"card-message":_vm.existingSwapMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }